import { Component, OnDestroy, OnInit } from '@angular/core';
import { ClientQuestionnaireResultBaseFactory } from './client-questionnaire-result-base.factory';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationError } from '@pristine-ts/class-validator';
import {
  ClientQuestionnaireOptions,
} from '../../../../../../../../../../common/src/options/client-questionnaire/client-questionnaire.options';
import {
  ClientQuestionnaireModel,
} from '../../../../../../../../../../common/dist/angular/models/client-questionnaire.model';
import {
  ClientQuestionnaireStatusEnum,
} from '../../../../../../../../../../common/src/enums/client-questionnaire/client-questionnaire-status.enum';
import { ClientQuestionnaireStore } from '../../../../stores/client-questionnaire.store';
import { TranslateService } from '@ngx-translate/core';
import {OptionsMapper} from "@magieno/angular-advanced-forms";
import { AlertMessageStore } from '../../../../../core/stores/alert-message.store';
import { FormLifecycleStatusEnum } from '@magieno/angular-advanced-forms';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { DateUtils } from '../../../../../core/utils/date.utils';
import { QuestionnaireUtils } from '../../../../utils/questionnaire.utils';

@Component({
  template: '',
  standalone: false,
})
export class ClientQuestionnaireResultBase<T extends ClientQuestionnaireOptions> implements OnInit, OnDestroy {
  questionnaireId: string;

  questionnaireSubscription: Subscription;
  formErrorsSubscription: Subscription;

  clientQuestionnaireResponse: ClientQuestionnaireModel;

  public lastModified: Date;

  public clientQuestionnaireStatus: ClientQuestionnaireStatusEnum;

  // @ts-ignore
  public advancedForm: AdvancedForm<T> = this.formFactory.create();
  public numberOfErrors = 0;
  protected optionsType: { new(...args: any[]): object; };

  constructor(public readonly formFactory: ClientQuestionnaireResultBaseFactory,
              private readonly clientQuestionnaireStore: ClientQuestionnaireStore,
              protected readonly translateService: TranslateService,
              private readonly activatedRoute: ActivatedRoute,
              protected readonly router: Router,
              private readonly optionsMapper: OptionsMapper,
              protected readonly dateUtils: DateUtils,
              // private readonly calculationsUtils: CalculationsUtils,
              private readonly alertMessageStore: AlertMessageStore,
  ) {

    // Start by setting the client questionnaire id
    this.questionnaireId = this.activatedRoute.snapshot.params.questionnaireId;
  }

  ngOnInit(): void {
    // Right away, we want to form to be set as loading.
    this.advancedForm.lifecycleStatus = FormLifecycleStatusEnum.Loading;

    this.activatedRoute.params.subscribe(params => {
      if (params.questionnaireId === undefined) {
        console.warn('Questionnaire id not defined');
        return;
      }

      this.questionnaireId = params.questionnaireId;

      // Unsubscribe all the subscriptions on route change.
      this.unsubscribeAll();

      // this.advancedForm.lifecycleStatus = FormLifecycleStatusEnum.Sending;

      this.questionnaireSubscription = this.clientQuestionnaireStore.get(params.questionnaireId).subscribe(async (clientQuestionnaireResponse) => {
        if (clientQuestionnaireResponse === undefined) {
          return;
        }

        if (clientQuestionnaireResponse.options) {
          // It's important to init the form since when parameters change, we need to reload it entirely.
          // todo: I hope that what I just changed is the expected behavior.
          const options: T = this.optionsMapper.map<T>(new this.optionsType() as T, clientQuestionnaireResponse.options);
          this.advancedForm.setValue(options);
          this.advancedForm.lifecycleStatus = FormLifecycleStatusEnum.Loading;

          // this.formService.form.updateModel(clientQuestionnaireResponse.options.options);
        }
        this.advancedForm.lifecycleStatus = FormLifecycleStatusEnum.Loading;

        this.clientQuestionnaireResponse = clientQuestionnaireResponse;

        this.clientQuestionnaireStatus = clientQuestionnaireResponse.status;

        // this.lastModified = this.calculationsUtils.getLastModifiedDate(clientQuestionnaireResponse);

        // this.advancedForm.state = FormStateEnum.Initial;

        this.postUpdateCallback();

        console.log(this.clientQuestionnaireResponse);
      });

      this.formErrorsSubscription = this.clientQuestionnaireStore.getErrors(params.formId).subscribe(errors => {
        this.numberOfErrors = errors.length;
      });
    });
  }

  /**
   * This method exists so that forms extending the base form can be notified when the calculation has
   * been updated and proceed to update some fields.
   */
  postUpdateCallback() {

  }

  ngOnDestroy() {
    console.log('Client questionnaire base is being destroyed');

    this.unsubscribeAll();
  }

  setErrors(validationErrors: ValidationError[]) {
    // const errors = this.calculationsUtils.getErrors(validationErrors);
    // this.clientQuestionnaireStore.setErrors(this.questionnaireId, errors);
  }

  getClientEmail() {
    if (this.clientQuestionnaireResponse === undefined) {
      return '...';
    }

    return this.clientQuestionnaireResponse.clientEmail;
  }

  getClientName() {
    if (this.clientQuestionnaireResponse === undefined) {
      return '...';
    }

    return this.clientQuestionnaireResponse.clientName;
  }

  getStatusText() {
    return QuestionnaireUtils.getStatusText(this.clientQuestionnaireStatus);
  }

  getTitleText() {
    if (this.clientQuestionnaireResponse === undefined) {
      return '...';
    }

    return QuestionnaireUtils.getName(this.clientQuestionnaireResponse.keyname);
  }

  getLastModifiedText() {
    if (this.clientQuestionnaireResponse === undefined) {
      return '...';
    }

    return this.dateUtils.getLastModifiedText(this.clientQuestionnaireResponse.updatedAt);
  }


  private unsubscribeAll() {
    this.questionnaireSubscription?.unsubscribe();
    this.formErrorsSubscription?.unsubscribe();
  }

  // getStatusText(): string {
  //     return this.calculationsUtils.getStatusText(this.calculationStatusEnum);
  // }
  //
  // getLastModifiedText() {
  //     return this.calculationsUtils.getLastModifiedText(this.lastModified);
  // }
}
